module.exports = __webpack_public_path__ + "images/patterns/pattern_bg_tri_line_yellow_35a498d50df47dcadf3712a389009bae.png";